import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./AddToProjectButton.module.css";

interface AddToProjectButtonProps {
    onClick: () => void;
}

const AddToProjectButton: React.FC<AddToProjectButtonProps> = ({ onClick }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    return (
        <button type="button" className={`${styles.root} add-to-project-button`} onClick={onClick}>
            <span className={`${styles.circle} add-to-project-circle`} aria-hidden>
                <span className={`${styles.plus} add-to-project-plus`} />
            </span>
            <span className={`${styles.text} add-to-project-text`}>{t("addtoProject")}</span>
        </button>
    );
};

export default AddToProjectButton;
